import { useState } from 'react';
import Hero from './components/Hero';
import Envelope from './components/Envelope';
import DateBlock from './components/DateBlock';
import Venue from './components/Venue';
import Timeline from './components/Timeline';
import DressCode from './components/DressCode';
import Countdown from './components/Countdown';
import RSVP from './components/RSVP';
import IntroScreen from './components/IntroScreen';

function OrnamentDivider() {
  return (
    <div className="flex items-center justify-center gap-4 py-2" style={{ background: 'transparent' }}>
      <div className="h-px w-16 sm:w-24 bg-[#A8323C]/25" />
      <span className="text-[#A8323C]/40 text-base font-serif select-none">✦</span>
      <div className="h-px w-4 bg-[#A8323C]/15" />
      <span className="text-[#A8323C]/25 text-xs font-serif select-none">✦</span>
      <div className="h-px w-4 bg-[#A8323C]/15" />
      <span className="text-[#A8323C]/40 text-base font-serif select-none">✦</span>
      <div className="h-px w-16 sm:w-24 bg-[#A8323C]/25" />
    </div>
  );
}

export default function Home() {
  const [introVisible, setIntroVisible] = useState(true);

  return (
    <>
      {introVisible && <IntroScreen onEnter={() => { setIntroVisible(false); window.scrollTo({ top: 0 }); }} />}
      <div className="relative overflow-hidden" style={{ background: '#F5F0E8' }}>
        <div style={{ position: 'relative', zIndex: 10 }}><Hero /></div>
        <OrnamentDivider />
        <div style={{ position: 'relative', zIndex: 10 }}><Envelope /></div>
        <OrnamentDivider />
        <div style={{ position: 'relative', zIndex: 10 }}><DateBlock /></div>
        <OrnamentDivider />
        <div style={{ position: 'relative', zIndex: 10 }}><Venue /></div>
        <OrnamentDivider />
        <div style={{ position: 'relative', zIndex: 10 }}><Timeline /></div>
        <OrnamentDivider />
        <div style={{ position: 'relative', zIndex: 10 }}><DressCode /></div>
        <OrnamentDivider />
        <div style={{ position: 'relative', zIndex: 10 }}><Countdown /></div>
        <OrnamentDivider />
        <div style={{ position: 'relative', zIndex: 10 }}><RSVP /></div>
      </div>
    </>
  );
}
